module.exports = __webpack_public_path__ + "img/vip-img8-2.aa9e1dbd.png";